import React from 'react';
import ReactDOM from 'react-dom/client';
import {
    createBrowserRouter,
    RouterProvider
} from "react-router-dom";
import App from './App';
import Footer from './components/Footer.js';
import { NewCampaign, OngoingCampaign, SharedCampaign, loader as campaignLoader } from './trackers/campaigns.js';
import { ChangePasswordPage, ContactPage, HelperPage, ManageAccountPage, PrivacyPage, TermsAndConditionsPage, TrackingGameListPage, WhatsNewPage, loader as helperLoader } from './pageDefinitions.js';
import EnemyIndex from './isofarianGuard/isofarianGuard_enemyIndex.js';

const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
    },
    {
        path: "/contactForm",
        element: <ContactPage />,
    },
    {
        path: "/privacy",
        element: <PrivacyPage />,
    },
    {
        path: "/termsAndConditions",
        element: <TermsAndConditionsPage />,
    },
    {
        path: "/manageAccount",
        element: <ManageAccountPage />
    },
    {
        path: "changePassword",
        element: <ChangePasswordPage />
    },
    {
        path: "/whatsNew",
        element: <WhatsNewPage />,
    },
    {
        path: "/trackingList",
        element: <TrackingGameListPage />
    },
    {
        path: "/tracker/:gameId/new",
        element: <NewCampaign />,
        loader: campaignLoader
    },
    {
        path: "/tracker/:gameId/:id",
        element: <OngoingCampaign />,
        loader: campaignLoader
    },
    {
        path: "/shared/:gameId/:id",
        element: <SharedCampaign />,
        loader: campaignLoader
    },
    {
        path: "/isofarianGuard/enemyIndex",
        element: <EnemyIndex />
    },
    {
        path: "/helper/:gameId",
        element: <HelperPage />,
        loader: helperLoader
    }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <div className="is-flex-direction-column fakeHero is-fullheight">
            <div className="container ml-2 mr-2 pr- mt-4 p-0 is-align-self-center is-fullheight">
                <RouterProvider router={router} />
            </div>
            {document.location.href.includes('/helper') ? null : <Footer />}
        </div>
    </React.StrictMode>
);


